import { z } from 'zod';
import { userIndustries } from './index.js';
export const userIndustrySchema = z.enum(userIndustries);
//# sourceMappingURL=contracts.js.map